module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev171"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("THE HORSE.")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "chapauthor1"
  }, [_c('em', [_vm._v("(Equus Caballus")]), _vm._v(", Linnæus.—"), _c('em', [_vm._v("Le Cheval")]), _vm._v(", Buffon.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("THE various excellencies of this noble animal, the grandeur of his stature, the elegance and proportion of his parts, the beautiful smoothness of his skin, the variety and gracefulness of his motions, and, above all, his utility, entitle him to a precedence in the history of the brute creation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Horse, in his domestic state, is generous, docile, spirited, and yet obedient; adapted to the various purposes of pleasure and convenience, he is equally serviceable in the draught, the field, or the race.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("There are few parts of the known world where the Horse is not produced; but if we would see him in the enjoyment of his native freedom, unsubdued by the restraints man has imposed upon him, we must look for him in the wild and extensive plains of Africa and Arabia, where he ranges without control in a state of entire independency. In those immense tracts, the wild Horses may be seen feeding together, in droves of four or five hundred; one of them always acting as sentinel, to give notice of approaching danger: this he does by a kind of snorting noise, upon which they all run off ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("with astonishing rapidity. The wild Horses of Arabia are esteemed the most beautiful in the world: they are of a brown colour, their mane and tail of black tufted hair, very short; they are smaller than the tame ones, are very active, and of great swiftness. The most usual method of taking them is by snares or pits formed in the sand. It is probable there were once wild Horses in Europe, which have long since been brought under subjection. Those found in America were originally of the Spanish breed, sent thither upon its first discovery, which have since become wild, and spread themselves over various parts of that vast continent. They are generally small, not exceeding fourteen hands high, with thick heads and clumsy joints; their ears and necks are longer than those of the English Horses. They are easily tamed; and if by accident they should regain their liberty, they seldom become wild again, but know their master, and may be easily caught by him.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("At the age of two years,")]), _c('span', {
    attrs: {
      "href": "#/html/9780226044859_233_not#pg2fn1",
      "id": "rpg2fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*"), _c('sup', [_vm._v("1")])]), _vm._v(" the Horse is in a condition to propagate. The mare is generally in season from the latter end of March till the "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("beginning of June; but her chief ardour for the Horse continues only fifteen or twenty days. She goes with young eleven months and some days; continues to breed till the age of sixteen or eighteen years; and lives, on an average, between twenty and thirty years.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the Horse is endowed with vast strength and powers, he seldom exerts either to the prejudice of his master: on the contrary, he shares with him in his labours, and seems to participate in his pleasures: generous and persevering, he gives up his whole powers to the service of his master; though bold and intrepid, he represses the natural vivacity and fire of his temper, and not only yields to the hand, but seems to consult the inclination of his rider.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it must continue to be matter of regret to every feeling mind, that these excellent qualities should be often shamefully abused in the most unnecessary exertions; and the honest labours of this noble animal thrown away in the ungrateful task of accomplishing the purposes of unfeeling folly, or lavished in gratifying the expectations of an intemperate moment.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c45368c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_08_gen.vue
// module id = 75
// module chunks = 0